import React from 'react';

const ThreeEasySteps = () => {
  return (
    <section className="py-8 md:py-16 bg-gray-50 hidden md:block">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">Buy tickets in Three easy steps</h2>
        <p className="text-base md:text-lg text-gray-600 mb-8 md:mb-12">Book your bus tickets online quickly and easily.</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Step 1 */}
          <div className="bg-white p-8 rounded-lg shadow-lg transform transition duration-300 hover:scale-105">
            <div className="flex justify-center mb-6">
              <img src="/images/step1.jpg" alt="Search Online Ticket" className="w-full h-48 object-cover rounded-md" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Search Online Ticket</h3>
            <p className="text-gray-600">Find your desired bus route by entering your origin, destination, and travel date.</p>
            <button className="mt-6 bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-2 px-4 rounded-md transition duration-300">Search Tickets</button>
          </div>

          {/* Step 2 */}
          <div className="bg-white p-8 rounded-lg shadow-lg transform transition duration-300 hover:scale-105">
            <div className="flex justify-center mb-6">
              <img src="/images/step2.jpg" alt="Select your trip" className="w-full h-48 object-cover rounded-md" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Select your trip</h3>
            <p className="text-gray-600">Choose from available buses, select your preferred seats, and review your booking details.</p>
            <button className="mt-6 bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-2 px-4 rounded-md transition duration-300 hidden md:block">Select Trip</button>
          </div>

          {/* Step 3 */}
          <div className="bg-white p-8 rounded-lg shadow-lg transform transition duration-300 hover:scale-105">
            <div className="flex justify-center mb-6">
              <img src="/images/step3.jpg" alt="Pay and Get Ticket" className="w-full h-48 object-cover rounded-md" />
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Pay and Get Ticket</h3>
            <p className="text-gray-600">Complete your secure payment and receive your e-ticket instantly via email or SMS.</p>
            <button className="mt-6 bg-[#16A34A] hover:bg-[#128a3a] text-white font-bold py-2 px-4 rounded-md transition duration-300 hidden md:block">Pay and Get Ticket</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ThreeEasySteps;